import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { IJourneyTrip, JOURNEY_TRIPS_SCHEMA } from '@web/dtos';
import { IGetGateway } from '../../gateways';

export interface IReconRouteRequest {
  ctx: string;
  onDemandOperatorIds: string[];
}

export class ReconRouteGateway implements IGetGateway<
  IReconRouteRequest,
  IApiResponse<IJourneyTrip[]>
> {
  private readonly restCallBuilder: RestCallBuilder<
    IReconRouteRequest,
    IJourneyTrip[]
  > = new RestCallBuilder<IReconRouteRequest, IJourneyTrip[]>([]);
  private readonly configService: AppConfigService = inject(AppConfigService);

  get(query: IReconRouteRequest): Observable<IApiResponse<IJourneyTrip[]>> {
    return this.restCallBuilder
      .getExternal(`${this.configService.get().general.efaUrl}/recon`, {
        ctx: query.ctx,
        onDemandOperatorIds: query.onDemandOperatorIds.join(','),
      })
      .validate(API_RESPONSE_SCHEMA(JOURNEY_TRIPS_SCHEMA), 'ReconRoute.get')
      .handleMessages()
      .build();
  }
}
